import { memo, useCallback } from "react";

// import { useMousePosition } from "@hooks/useMousePosition";
import { useStore } from "@hooks/useZustandProvider";
import Container from "@ui-kit/Container/Container";

import AdvBannerBlockLayout from "./AdvBannerBlock.layout";
import s from "./AdvBannerBlock.module.scss";
import { collectionType } from "./datas";

const AdvBannerBlock = ({ settings, data, updateField }) => {
  // TODO: pass isWidget from parent component
  // const { isWidget } = useMousePosition();

  const { cms, updateCollectionType } = useStore();
  const { isWidget } = cms.page;
  const { isWidgetEditing } = cms.widget;
  const { isEditMode } = cms.uiOptions;
  const { collections = {} } = data;
  const { items = [] } = collections?.[collectionType] || {};
  const cursorNotice = "Double click to edit banner";

  const hasItemsToShow = !!items.filter((item) => {
    return typeof item.isShow === "boolean" ? item.isShow : true;
  }).length;

  // const hasItemsToShow = !!items.filter((item) => item.isShow).length;

  const handleClickToEdit = useCallback((e) => {
    switch (e.detail) {
      case 2: // double click
        updateCollectionType(e);
    }
  }, []);

  return isEditMode || hasItemsToShow ? (
    <Container>
      <Container full={false}>
        <section>
          <AdvBannerBlockLayout
            className={s.advBanner}
            items={items}
            isEditMode={isEditMode}
            isWidgetEditing={isWidgetEditing}
            isWidget={isWidget}
            cursorNotice={cursorNotice}
            collectionType={collectionType}
            handleClickToEdit={handleClickToEdit}
          />
        </section>
      </Container>
    </Container>
  ) : null;
};

export default memo(AdvBannerBlock);
